<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
import { useDesignerStore } from '@/stores/designerStore.ts'
import {RouteNames} from "@/router";
import {onMounted} from "vue";

const designerStore = useDesignerStore();

onMounted(() => {
  window.document.querySelector('html')?.attributes
})
</script>

<template>
  <header>
    <nav>
<!--      <RouterLink :to="{name: RouteNames.CustomImageDesigner, params: {imageId: 2}}">Custom image designer</RouterLink>
      <RouterLink :to="{name: RouteNames.PredefinedLabelDesigner, params: {labelId: 4}}">Predefined label designer</RouterLink>
      <RouterLink :to="{name: RouteNames.LabelAdminDesigner, params: {labelId: 4}}">Admin label designer</RouterLink>-->
    </nav>
  </header>

  <div>
    <RouterView />
  </div>
</template>

<style scoped>
nav a {
  color: black;
  border: 1px solid black;
  margin: 3px;
  padding: 3px;
}
</style>
